import { idID } from '@mui/material/locale';
import { Button, Modal, notification, Table, Space } from 'antd';
import React, { useState } from 'react';
import shortid from 'shortid';
import { copySatz, getAllSatzPlan } from '../util/APIUtils';

function CopySatzPopup(props) {
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [modalText, setModalText] = useState('Content of the modal');
    const [satzs, setSatzs] = useState([]);
    const [selectedLines, setSelectedLines] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const projectReportId = props.projectReportId || 0

    let fetchPlanSatz = React.useCallback(async () => {
        // if(!open) {
        //     return;
        // }
        let promise;
        setLoading(true);
        promise = getAllSatzPlan(props.projectDetailId);
        if (!promise) {
            return;
        }
        promise.then(response => {
            console.log(response)
            setSatzs(response.map(obj => ({ ...obj, key: shortid.generate() })));
            setLoading(false);

        }).catch(error => {
            console.log(error)
            setLoading(false)
        });
    }, [])

    const satzCopy = () => {
        let promise;
        console.log(props.projectDetailId)
        promise = copySatz(props.projectDetailId)
        if (!promise) {
            return;
        }
        promise.then(response => {
            setLoading(false)
            notification.success({
                message: 'Kultursaat',
                description: "Erfolgreich kopiert"
            });
            props.fetchSatz();
            setOpen(false); 
            setConfirmLoading(false);
        }).catch(error => {
            console.log(error)
            notification.warn({
                message: 'Kultursaat',
                description: "Kopieren fehlgeschlagen"
            });
            setOpen(false);
            setConfirmLoading(false);
        });
    }
    React.useEffect(() => {
        fetchPlanSatz();
    }, [fetchPlanSatz]);

    const showModal = () => {
        setOpen(true);
    };

    const handleOk = () => {
        setConfirmLoading(true);
        satzCopy()


    };

    const handleCancel = () => {
        console.log('Clicked cancel button');
        setOpen(false);
    };

    const onSelectChange = (newSelectedRowKeys) => {
        console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rndInt = Math.floor(Math.random() * 1000) + 1

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setSelectedLines(selectedRows)
        },
        getCheckboxProps: (record) => ({
            disabled: record.name === 'Disabled User',
            name: record.name,
        }),
    };

    const columns = [
        {
            title: 'Satz',
            dataIndex: 'description',
        }
    ];
    return (
        <>
            <Button type="primary" onClick={showModal}>
                + Kopie
            </Button>
            {open &&
                <Modal
                    width={800} forceRender
                    title="Kopie vom plan"
                    visible={open}
                    onOk={handleOk}
                    confirmLoading={confirmLoading}
                    onCancel={handleCancel}
                >
                    {/* <Table
                    rowSelection={{
                        type: 'checkbox',
                        ...rowSelection,
                    }}
                    columns={columns}
                    dataSource={lines} /> */}
                    <Space direction='vertical' style={{width: '100%'}}>
                    <Button onClick={fetchPlanSatz}>Aktualisierung</Button>


                    <Table
                        size='small'
                        rowSelection={{
                            type: 'checkbox',
                            ...rowSelection,
                        }}
                        columns={columns}
                        dataSource={
                            satzs
                        }
                    />
                    </Space>
                </Modal>}
        </>
    );
};
export default CopySatzPopup;